import { createContext } from 'react';

import { ncrMyTasksInitialState } from './NCRMyTasksReducer';

export const NcrMyTasksContext = createContext(ncrMyTasksInitialState);
